import {
  FETCH_USERLOGIN_REQUEST,
  FETCH_USERLOGIN_SUCCESS,
  FETCH_USERLOGIN_FAILURE,
  CREATE_USERLOGIN_REQUEST,
  CREATE_USERLOGIN_SUCCESS,
  CREATE_USERLOGIN_FAILURE,
  UPDATE_USERLOGIN_REQUEST,
  UPDATE_USERLOGIN_SUCCESS,
  UPDATE_USERLOGIN_FAILURE,
  DELETE_USERLOGIN_REQUEST,
  DELETE_USERLOGIN_SUCCESS,
  DELETE_USERLOGIN_FAILURE,
} from "./userActionTypes";
const initialState = {
  userLoginData: [],
  loading: false,
  error: null,
};
const userLoginReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_USERLOGIN_REQUEST:
      return { ...state, loading: true, error: null };
    case FETCH_USERLOGIN_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        userLoginData: action.payload.data,
      };
    case FETCH_USERLOGIN_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        userLoginData: [],
      };
    case CREATE_USERLOGIN_REQUEST:
      return { ...state, loading: true, error: null };
    case CREATE_USERLOGIN_SUCCESS:
      return {
        ...state,
        loading: false,
        userLoginData: action.payload.data,
        error: null,
      };
    case CREATE_USERLOGIN_FAILURE:
      return { ...state, loading: false, error: action.payload };
    case UPDATE_USERLOGIN_REQUEST:
      return { ...state, loading: true, error: null };
    case UPDATE_USERLOGIN_SUCCESS:
      return {
        ...state,
        loading: false,
        userLoginData: action.payload.data,
        error: null,
      };
    case UPDATE_USERLOGIN_FAILURE:
      return { ...state, loading: false, error: action.payload };
    case DELETE_USERLOGIN_REQUEST:
      return { ...state, loading: true, error: null };
    case DELETE_USERLOGIN_SUCCESS:
      return {
        ...state,
        loading: false,
        userLoginData: action.payload.data,
        error: null,
      };
    case DELETE_USERLOGIN_FAILURE:
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
};
export default userLoginReducer;
